import { allGuides } from 'content-collections'
import { groupGuidesByHub, visibleSorted } from '#app/utils/content.ts'
import { buildMeta, collectionJsonLd } from '#app/utils/seo.ts'
import { ContentIndex } from '../components/content-index'
import { type Route } from './+types/index.ts'

const GUIDES_TITLE = 'Backlink Guides | Competitor Backlinks'
const GUIDES_DESCRIPTION =
	'Jargon-free guides to competitor backlink research, link building, and SEO, grouped by topic with every term defined and no hype.'

export const meta: Route.MetaFunction = () => [
	...buildMeta({
		title: GUIDES_TITLE,
		description: GUIDES_DESCRIPTION,
		path: '/guides',
		image: '/img/og/guides.png',
	}),
	// The hub index is where the topic structure lives, so it states its
	// membership explicitly rather than leaving the relationship implicit.
	{
		'script:ld+json': collectionJsonLd({
			title: GUIDES_TITLE,
			description: GUIDES_DESCRIPTION,
			name: 'Guides',
			path: '/guides',
			items: visibleSorted(allGuides).map((doc) => ({
				title: doc.title,
				path: `/guides/${doc.slug}`,
			})),
		}),
	},
]

export default function GuidesIndex() {
	return (
		<ContentIndex
			eyebrow="Guides"
			title="Jargon-free guides to competitor backlinks"
			description="Step-by-step walkthroughs of link research and link building, with every term defined the moment it appears, and honest about when free is enough."
			basePath="/guides"
			entries={visibleSorted(allGuides)}
			// Grouped rather than one flat list: with nineteen guides a single grid
			// hides the structure, and the hubs are the actual product of the
			// content plan. `groupGuidesByHub` keeps unlisted slugs in a trailing
			// group, so a new guide can never fall off this page.
			groups={groupGuidesByHub(visibleSorted(allGuides))}
		/>
	)
}
